import { useEffect } from 'react';

/**
 * tourNav — petit registre mutable (pas du state React) permettant au tour guidé global
 * (TourContext/TourSpotlight) de piloter la navigation interne d'écrans profonds (onglet,
 * sous-vue Entraînements, sous-onglet Programmes...) sans avoir à faire remonter leur state
 * local via des props/contexts imbriqués. Chaque écran concerné enregistre son setter au
 * montage et le désenregistre au démontage via `useTourRegister`.
 */
export const tourNav = {};

export function useTourRegister(key, setter) {
  useEffect(() => {
    tourNav[key] = setter;
    return () => { if (tourNav[key] === setter) tourNav[key] = null; };
  }, [key, setter]);
}
